var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnitedKingdominline = function SvgUnitedKingdominline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.102 0h30v30h-30V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.102 0h10.002v30H.101V0Z",
    fill: "#009A49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.102 0h10.002v30H20.102V0Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.102 0h30v30h-30V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.102 0v3.75L18.969 15l11.133 10.957V30h-3.926L14.984 18.984 4.086 30H.102v-3.984L11 15.059.102 4.336V0h3.632l11.25 11.016L25.883 0h4.219Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.883 18.984.644 1.993L2.563 30H.102v-.176l10.78-10.84Zm7.265-.703 3.165.469 8.789 8.613V30L18.148 18.281ZM30.102 0l-11.25 11.484-.235-2.578L27.407 0h2.695Zm-30 .059L11.41 11.133l-3.457-.469L.102 2.871V.06Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.414 0v30h9.375V0h-9.375ZM.102 10.313v9.374h30v-9.375h-30Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.102 12.188v5.624h30v-5.625h-30ZM12.289 0v30h5.625V0H12.29Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.102,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.102)",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgUnitedKingdominline;